import React, { useState, useRef, useEffect } from "react";
import { BASE_URL } from "../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, Row, Col, Container, Card, Button, InputGroup } from 'react-bootstrap';
import '../../CommonCSS/SocietyCSS.css';


const Homework = () => {

  const [formData, setFormData] = useState({
    std_id: '',
    div_id: '',
    stud: '',
    reply_till_date: '',
    homework_txt: '',
    speechText: "",
    fileType: "",
    savedFilename: "",
    pdfFile: null,

  });

  const [isListening, setIsListening] = useState(false);
  const recognitionRef = useRef(null);
  const [homeworkFiles, setHomeworkFiles] = useState([]);
  const [pdfURL, setPdfURL] = useState(null);
  const fileInputRef = useRef(null);
  const [ddlStandards, setDdlStandards] = useState([]);
  const [ddlDivisions, setDdlDivisions] = useState([]);

  // const [showModal, setShowModal] = useState(false);
  // const [showIntModal, setShowIntModal] = useState(false);
  // const [showDiscountModal, setShowDiscountModal] = useState(false);
  // const [showParkingModal, setShowParkingModal] = useState(false);

  useEffect(() => {
    const fetchLists = async () => {
      try {
        const stdresult = await axios.get(`${BASE_URL}/api/ddl_all_standards`);
        setDdlStandards(stdresult.data);
        const res = await axios.get(`${BASE_URL}/api/ddl_all_division`);
        setDdlDivisions(res.data || []);
        //        console.log('premtypeRes.data =====> ', premtypeRes.data);
      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };
    fetchLists();
  }, []);

  useEffect(() => {

    if ("webkitSpeechRecognition" in window) {
      const recognition = new window.webkitSpeechRecognition();
      recognition.continuous = true;
      recognition.interimResults = false;

      recognition.onresult = (event) => {
        const transcript = event.results[event.results.length - 1][0].transcript;
        setFormData((prev) => ({
          ...prev,
          speechText: prev.speechText + " " + transcript
        }));
      };

      recognition.onerror = () => setIsListening(false);

      recognition.onend = () => {
        // When speech recognition fully stops
        setIsListening(false);
      };

      recognitionRef.current = recognition;
    }

  }, []);

  const handleFileUpload = (e) => {

    const file = e.target.files[0];
    if (!file) return;

    setHomeworkFiles(e.target.files);

    // setFileName(file.name);

    const previewURL = URL.createObjectURL(file);
    setPdfURL(previewURL);

    setFormData(prev => ({
      ...prev,
      pdfFile: file
    }));

  };

  const startListening = () => {
    if (!recognitionRef.current) {
      alert("Speech Recognition not supported");
      return;
    }
    setIsListening(true);
    recognitionRef.current.start();
  };

  const stopListening = () => {
    if (recognitionRef.current) {
      recognitionRef.current.stop();
    }
    setIsListening(false);
  };

  const [isEditable, setIsEditable] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleMoveSpeachToTextBox = () => {

    setFormData(prev => ({
      ...prev,
      homework_txt:
        prev.homework_txt
          ? prev.homework_txt + "\n" + prev.speechText
          : prev.speechText,
      speechText: ""
    }));

  };

  const handleEmptySpeechText = async () => {

    const confirmClear = window.confirm("Sure you want to move clear Speech Text ?");
    if (!confirmClear) return;

    setFormData(prev => ({
      ...prev,
      speechText: "",
    }));

  };


  const handleSave = async () => {

    if (!formData.std_id) {
      alert("Please select Standard");
      return;
    }

    if (!formData.div_id) {
      alert("Please select Division");
      return;
    }

    if (!formData.homework_txt) {
      alert("Please enter Homework text");
      return;
    }

    const confirmSave = window.confirm("Sure you want to save Homework?");
    if (!confirmSave) return;

    try {

      const formDataToSend = new FormData();

      formDataToSend.append("std_id", formData.std_id);
      formDataToSend.append("div_id", formData.div_id);
      formDataToSend.append("stud", formData.stud);
      formDataToSend.append("reply_till_date", formData.reply_till_date);
      formDataToSend.append("homework_txt", formData.homework_txt);

      if (formData.pdfFile) {
        formDataToSend.append("homeworkFile", formData.pdfFile);
      }

      const response = await axios.post(
        `${BASE_URL}/api/upload_Homework`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );

      alert("Homework saved successfully!");

      console.log("Response:", response.data);

      // Optional: Reset form
      setFormData({
        std_id: '',
        div_id: '',
        stud: '',
        reply_till_date: '',
        homework_txt: '',
        speechText: "",
        fileType: "",
        savedFilename: "",
        pdfFile: null,
      });

      setPdfURL(null);

    } catch (error) {
      console.error("Homework Save Error:", error);
      alert("Homework save failed!");
    }
  };

  return (
    <Container fluid className="p-3">
      <Card style={{ marginTop: '10px', padding: '15px' }}>
        <Row className="mb-3">

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "90px" }}>
                Standard
              </InputGroup.Text>
              <select
                className="form-select"
                name="std_id"
                value={formData.std_id}
                onChange={handleChange}
              >
                <option value="">-- Select Standard--</option>
                {ddlStandards.map(std => (
                  <option key={std.std_id} value={std.std_id}>{std.std_name}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "90px" }}>
                Division
              </InputGroup.Text>
              <select
                className="form-select"
                name="div_id"
                value={formData.div_id}
                onChange={handleChange}
              >
                <option value="">-- Select Division--</option>
                {ddlDivisions.map(div => (
                  <option key={div.div_id} value={div.div_id}>{div.div_name}</option>
                ))}

              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "90px" }}>
                Students
              </InputGroup.Text>
              <select
                className="form-select"
                name="stud"
                value={formData.stud}
                onChange={handleChange}
              >
                <option value="">-- Select Option--</option>
                <option value="Y">Yes</option>
                <option value="N">No</option>

              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}>
                Reply Till Date
              </InputGroup.Text>
              <input
                type="date"
                style={{ textAlign: 'left' }}
                className="form-control"
                name="reply_till_date"
                value={formData.reply_till_date}
                onChange={handleChange}
              />
            </InputGroup>
          </Col>
        </Row>

        <Row className="mb-3">

          <Col md={6}>
            <Form.Floating className="mb-3">
              <Form.Control
                as="textarea"
                style={{ height: "300px" }}
                name="homework_txt"
                value={formData.homework_txt}
                onChange={handleChange}
                placeholder="Type your notice here..."
              />
              <label className="fw-bold">Home Work Text</label>
              <div style={{ textAlign: "right", fontSize: "12px", color: "#555" }}>
                {formData.homework_txt.length} characters
              </div>
            </Form.Floating>
          </Col>
          {/* Speech to Text Row */}
          <Col md={6}>
            <Form.Floating className="mb-3">
              <Form.Control
                as="textarea"
                style={{ height: "250px" }}
                name="speechText"
                value={formData.speechText}
                onChange={handleChange}
                readOnly
                placeholder="Speak your notice here..."
              />
              <label className="fw-bold">Speech To Text</label>
            </Form.Floating>
            <div className="mt-2">
              {!isListening ? (
                <Button variant="primary" onClick={startListening} className="me-2">
                  🎤 Start Listening
                </Button>
              ) : (
                <Button variant="danger" onClick={stopListening} className="me-2">
                  ⏹ Stop
                </Button>
              )}
              <Button variant="primary" onClick={handleMoveSpeachToTextBox} disabled={formData.speechText.length === 0} className="me-2">
                Move Text To Notice Text
              </Button>
              <Button variant="secondary" onClick={handleEmptySpeechText} disabled={formData.speechText.length === 0} className="me-2">
                Empty Speech Text
              </Button>
            </div>
          </Col>

          {/* PDF Upload */}
          <Col md={6}>
            {/* <Form.Label>Select PDF File:</Form.Label> */}
            <Form.Control type="file" accept="application/pdf" onChange={handleFileUpload} ref={fileInputRef} id="formFileSm" />

            {pdfURL && (
              <div className="mt-3">
                <h6>PDF Preview:</h6>
                <iframe
                  src={pdfURL}
                  title="PDF Preview"
                  width="100%"
                  height="300px"
                  style={{ border: "1px solid #ccc" }}
                ></iframe>
              </div>
            )}
          </Col>
        </Row>


        <Row className="mb-3 justify-content-end">
          <Col md="auto">
            <button className="btn btn-success" style={{ width: "100px" }} onClick={handleSave}>Save</button>
          </Col>
        </Row>
      </Card>

    </Container>
  );
};
export default Homework;
